import { assetUrl, formatDate, formatDMy } from "../../utils/helpers";
import TourStatusBadge from "./TourStatusBadge";
import TourRequirementBadge from "./TourRequirementBadge";

export default function TourCard({ tour, onOpen, badgeVisibility }) {
  const access = tour?.access;
  const eligibility = access?.eligibility || {};
const isCompleted =
  access?.status === "completed" ||
  access?.booking?.isCompleted === true;
  const handleOpen = () => {
  if (isCompleted) return;
  onOpen?.(tour);
};
// console.log('badgeVisibilityTourCard', badgeVisibility) 
  return (
    <div className="col-sm-6 col-6 w-20 mb-3">
      <div
  className={`sntravel ${isCompleted ? "tourCardDisabled" : "cursor"}`}
  onClick={handleOpen}
  role={isCompleted ? undefined : "button"}
  tabIndex={isCompleted ? -1 : 0}
  aria-disabled={isCompleted ? "true" : undefined}
  onKeyDown={(event) => {
    if (!isCompleted && (event.key === "Enter" || event.key === " ")) {
      event.preventDefault();
      handleOpen();
    }
  }}
>
        <div className="TImg">
          {badgeVisibility == "true" ?(<TourStatusBadge access={access} />): ""}
          <TourRequirementBadge tour={tour} />

          <img
            src={
              tour?.banner_image
                ? assetUrl + tour.banner_image
                : "/images/travel1.png"
            }
            className="img-fluid w-100"
            alt={tour?.title || "Tour"}
          />
        </div>

        <div className="content">
          <div className="tourTitleRow">
            <h4>{tour?.title}</h4>
          </div>

          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-regular fa-calendar"></i>
              </span>
              <div>
                <small>Tour Month</small>
                <strong>{formatDate(tour?.tour_month_date)}</strong>
              </div>
            </div>
          </div>

          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-solid fa-calendar-check"></i>
              </span>
              <div>
                <small>Booking Till</small>
                <strong>{formatDMy(tour?.last_application_date)}</strong>
              </div>
            </div>
          </div>

          <div className="tourMeta">
            <div className="tourMetaItem">
              <span className="tourMetaIcon">
                <i className="fa-solid fa-location-dot"></i>
              </span>
              <div>
                <strong>{tour?.country || "-"}</strong>
              </div>
            </div>
          </div>

          {(access?.isApplied || access?.isEligible) &&
          !access?.booking?.isUpcoming &&
          !access?.booking?.isCompleted ? (
            <div className="tourEligibility">
              <i className="fa-solid fa-ticket"></i>
              <span>
                Eligible For: <strong>{eligibility.alreadyApplied || 0} / {eligibility.maxPassengers || 0}</strong>
              </span>
            </div>
          ) : (
            <div className="tourEligibility empty">&nbsp;</div>
          )}
        </div>
      </div>
    </div>
  );
}
